import type { BookingStorePayload, Extras } from '../../models/booking';
import type { LocationDetail } from '../../models/location-detail';

export interface WebState {
  carDetail: BookingStorePayload;
  locationDetail: LocationDetail;
  locationAutoCompleteList: { name: string }[];
  isSearchingLocation: boolean;
  filters: {
    name: string[];
    make: string[];
    transmission: string[];
    seats: number[];
    type: string[];
  };
  error: unknown;
  extras: Extras[];
  extrasLoading: boolean;
  extrasError: unknown;
}

export const INITIAL_WEB_STATE: WebState = {
  carDetail: {
    carDetail: {
      id: 0,
      make: '',
      model: '',
      name: '',
      transmission: '',
      dailyRate: '',
      weeklyRate: '',
      monthlyRate: '',
      rating: 0,
      hourlyRate: '',
      fuelType: '',
      perMinuteRate: '',
      mileage: 0,
      kilometerAllowance: 0,
      seats: 0,
      chasisNo: '',
      pickupLocation: '',
      dropoffLocation: '',
      pickupDate: '',
      dropoffDate: '',
      year: 0,
      doors: 0,
      engine: '',
      availability: '',
      type: '',
      createdAt: '',
      updatedAt: '',
      deletedAt: '',
      features: [
        {
          id: 0,
          vehicleId: 0,
          safetyAndComfortFeatures: [],
          exteriorFeatures: [],
          interiorFeatures: [],
        },
      ],
      images: [
        {
          documentName: '',
          documentPath: '',
        },
      ],
      carImages: [],
      featured: false,
      hotDeal: false,
    },
    selectedPrice: 0,
    package: 'per_minute',
    extras: [
      {
        id: 0,
        type: '',
        price: '',
        range: 0,
        code: '',
        typeAr: '',
      },
    ],
    depositOption: {
      name: '',
      description: '',
      key: '',
      isSelected: false,
    },
    total: 0,
    depositAmount: 0,
    baseRent: 0,
    pickupType: 'self_pickup',
    sameLocation: false,
    pickupLocation: '',
    dropoffLocation: '',
    isUnlimitedKM: false,
  },
  locationDetail: {
    pickupDate: '',
    dropoffDate: '',
  },
  locationAutoCompleteList: [],
  isSearchingLocation: false,
  filters: {
    name: [],
    make: [],
    transmission: [],
    seats: [],
    type: [],
  },
  error: null,
  extras: [],
  extrasLoading: false,
  extrasError: null,
};
